import { Currency } from '../types/currency';
import { CurrencyDTO } from '../types/dto/currency.dto';

/**
 * Maps currency DTO to application Currency class.
 */
export const mapCurrencyFromDTO = (dto: CurrencyDTO): Currency => {
  return new Currency(dto.code, dto.displayName);
};

/**
 * Maps application Currency class to DTO.
 */
export const mapCurrencyToDTO = (currency: Currency): CurrencyDTO => {
  return {
    code: currency.code,
    displayName: currency.displayName,
  };
};
